import { GOOGLE_AUTH, AUTH } from '../constants/actionTypes';
import * as api from '../api/index.js';

export const signin = (formData, history) => async (dispatch) => {
    try {
        const {data} = await api.signIn(formData);

        dispatch({type:AUTH, data})
        
        history.push('/');
    } catch (error) {
        
    }
}

export const googleSignin = (token, history) => async (dispatch) => {
    try {
        const {data} = await api.googleSignin(token);

        dispatch({type:GOOGLE_AUTH, data});
        history.push('/');
        
    } catch (error) {
        
    }
}
export const signup = (formData, history) => async (dispatch) => {
    try {
        const {data} = await api.signUp(formData);

        dispatch({type:AUTH, data})

        history.push('/');
    } catch (error) {
        
    }
}